import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { validateEmail } from '@/lib/utils/emailValidation'
import type { IdGenerator } from '@/lib/id'
import { randomIdGenerator } from '@/lib/id'

interface EmailValidationIndicatorProps {
    email: string
    showValidation?: boolean
    touched?: boolean
    id?: string
    idGenerator?: IdGenerator
}

const EmailValidationIndicator: React.FC<EmailValidationIndicatorProps> = ({
    email,
    showValidation = true,
    touched = false,
    id,
    idGenerator = randomIdGenerator,
}) => {
    const { t } = useTranslation()

    if (!showValidation || !touched || !email) {
        return null
    }

    const validation = validateEmail(email)

    if (validation.isValid) {
        return null
    }

    const errorId = id || `email-validation-error-${idGenerator.generate()}`

    return (
        <Box
            id={errorId}
            sx={{
                mt: 0.5,
                px: 1,
            }}
            role="alert"
            aria-live="polite"
        >
            <Typography
                variant="caption"
                color="error"
                sx={{
                    fontSize: '0.75rem',
                    fontWeight: 500,
                }}
            >
                {t(`auth:${validation.errorMessage}`)}
            </Typography>
        </Box>
    )
}

export default EmailValidationIndicator
